import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import { SxProps } from '@mui/material/styles'
import { ReactNode } from 'react'

const boxLayoutStyle: SxProps = {
  minHeight: { xs: '75dvh', sm: '100dvh' },
  maxWidth: 640,
  width: '100%',
  margin: 'auto',
}

const defaultContentStyle: SxProps = {
  padding: { xs: '24px', sm: '48px' },
  borderRadius: '8px',
  width: '100%',
}
type CenteredBoxLayoutProps = {
  children: ReactNode
}
const CenteredBoxLayout: React.FC<CenteredBoxLayoutProps> = ({ children }) => (
  <Stack
    spacing={0}
    direction="row"
    sx={[
      {
        alignItems: 'center',
        justifyContent: 'center',
      },
      ...(Array.isArray(boxLayoutStyle) ? boxLayoutStyle : [boxLayoutStyle]),
    ]}>
    <Paper sx={defaultContentStyle}>{children}</Paper>
  </Stack>
)

export default CenteredBoxLayout
